import * as THREE from "three";
import * as getNormals1 from "polyline-normals";
import * as inherits1 from "inherits";
import { Color } from "three";

import * as curve1 from "adaptive-bezier-curve";
import * as normalize1 from "normalize-path-scale";

import { LineMesh } from "./geo/line-mesh";
import { BasicShader } from "./mat/shader-material";
import { BasicVolumeShader } from "./mat/shader-material";

var curve = curve1.default;
var normalize = normalize1.default;
var inherits = inherits1.default;
var getNormals = getNormals1.default;

const areaWidth = 108;
const areaHeight = 68;

const colorsLight = [0xffffff, 0x7c7d79];

const buildField = () => {
  const domainWidth = 1.976; // Domain width
  const domainHeight = 1.275; // Domain height
  //  1.259; // Domain height

  const rows = 12 + 1;
  const cols = 20 + 1;

  const planeWidth = domainWidth / cols;
  const planeHeight = domainHeight / rows;

  let colorHero = colorsLight[0];

  var container = new THREE.Group();

  var pitchOutlineMaterial = new THREE.ShaderMaterial(
    BasicShader({
      side: THREE.DoubleSide,
      diffuse: colorHero,
      thickness: 0.002,
    })
  );

  var matss = new THREE.ShaderMaterial(
    BasicVolumeShader({
      side: THREE.DoubleSide,
      diffuse: colorHero,
      thickness: 0.001,
    })
  );


  var mat2 = new THREE.ShaderMaterial(
    BasicShader({
      side: THREE.DoubleSide,
      diffuse: colorHero,
      thickness: 0.001,
    })
  );


  var middleLineMaterial = new THREE.ShaderMaterial(
    BasicShader({
      side: THREE.DoubleSide,
      diffuse: colorHero,
      thickness: 0.001,
    })
  );

  var goaleLineMaterial = new THREE.ShaderMaterial(
    BasicShader({
      side: THREE.DoubleSide,
      diffuse: colorHero,
      thickness: 0.001,
    })
  );

  var mat4 = new THREE.ShaderMaterial(
    BasicShader({
      side: THREE.DoubleSide,
      diffuse: colorHero,
      thickness: 0.001,
    })
  );

  const width = domainWidth - planeWidth;
  const height = domainHeight - planeHeight;

  let edge = (66.18 * height) / 90;
  let edge2 = (12.82 * height) / 90;
  let pushedhe = (49.65 * height) / 90;

  // 1.9047619047619047 1.1076923076923078

  var fieldOutline = [];
  fieldOutline.push(
    [-width, -height],
    [0, -height],
    [0, 0],
    [-width, 0],
    [-width, -height],
    [0, -height]
  );

  /*
0
: 
(2) [-2.05, -1.1921538461538466]
1
: 
(2) [0.050000000000000044, -1.1921538461538466]
2
: 
(2) [0.050000000000000044, 0.029076923076923236]
3
: 
(2) [-2.05, 0.029076923076923236]
4
: 
(2) [-2.05, -1.1921538461538466]
5
: 
(2) [0.050000000000000044, -1.1921538461538466]
*/
  var curveGeometry = new LineMesh(fieldOutline);
  var pitchOutlineMesh = new THREE.Mesh(curveGeometry, pitchOutlineMaterial);
  container.add(pitchOutlineMesh);
  pitchOutlineMesh.position.x = width / 2.0005;
  pitchOutlineMesh.position.y = height / 2.005;

  var middleline = [];
  middleline.push([0, -height / 2], [0, height / 2]);
  var middlelinegeo = new LineMesh(middleline);
  var middlelinemesh = new THREE.Mesh(middlelinegeo, middleLineMaterial);
  container.add(middlelinemesh);

  var goalOutline = [];
  goalOutline.push(
    [-width / 2, -height / 2.09 + planeHeight * 2],
    [-width / 2 + planeWidth * 3.202, -height / 2.09 + planeHeight * 2],
    [-width / 2 + planeWidth * 3.202, height / 2.09 - planeHeight * 2],
    [-width / 2, height / 2.09 - planeHeight * 2]
  );
  var goalGeometry = new LineMesh(goalOutline);
  container.add(new THREE.Mesh(goalGeometry, middleLineMaterial));

  var goalOutline2 = [];
  goalOutline2.push(
    [width / 2, -height / 2.09 + planeHeight * 2],
    [width / 2 - planeWidth * 3.202, -height / 2.09 + planeHeight * 2],
    [width / 2 - planeWidth * 3.202, height / 2.09 - planeHeight * 2],
    [width / 2, height / 2.09 - planeHeight * 2]
  );
  var goalGeometry2 = new LineMesh(goalOutline2);
  container.add(new THREE.Mesh(goalGeometry2, middleLineMaterial));

  var goalAreaOutline = [];
  goalAreaOutline.push(
    [-width / 2, -height / 2.15 + planeHeight * 4],
    [-width / 2 + planeWidth * 1.18, -height / 2.15 + planeHeight * 4],
    [-width / 2 + planeWidth * 1.18, height / 2.15 - planeHeight * 4],
    [-width / 2, height / 2.15 - planeHeight * 4]
  );
  var goalAreaGeometry = new LineMesh(goalAreaOutline);
  container.add(new THREE.Mesh(goalAreaGeometry, mat4));

  var goalAreaOutline2 = [];
  goalAreaOutline2.push(
    [width / 2, -height / 2.15 + planeHeight * 4],
    [width / 2 - planeWidth * 1.18, -height / 2.15 + planeHeight * 4],
    [width / 2 - planeWidth * 1.18, height / 2.15 - planeHeight * 4],
    [width / 2, height / 2.15 - planeHeight * 4]
  );
  var goalAreaGeometry2 = new LineMesh(goalAreaOutline2);
  container.add(new THREE.Mesh(goalAreaGeometry2, mat4));

  var circle = [];
  let scale = 0.12;
  let a = 1.00005519 * scale;
  let b = 0.55342686 * scale;
  let c = 0.99873585 * scale;
  let div = 200;

  let arctopleft = [];
  arctopleft.push(...curve([0, -a], [b, -c], [c, -b], [a, 0], div));

  var arctopleftgeo = new LineMesh(arctopleft);
  var arctopleftgeomesh = new THREE.Mesh(arctopleftgeo, mat4);
  //container.add(arctopleftgeomesh);

  circle.push(...curve([0, -a], [b, -c], [c, -b], [a, 0], div));
  //circle.push([a,0]);
  // Top-Right Arc
  circle.push(...curve([0, a], [b, c], [c, b], [a, 0], div));
  // Top-Left Arc
  // circle.push([a,0]);

  circle.push(...curve([0, a], [-b, c], [-c, b], [-a, 0], div));
  // Bottom-Left Arc
  //  circle.push([0,a]);
  circle.push(...curve([-a, 0], [-c, -b], [-b, -c], [0, -a], div));

  var curveGeometry2 = new LineMesh(circle);



  // NEW SETUP


  let ringWidthBase = 0.0015;
  // CENTER RING
  let ringWidth =ringWidthBase;
  let ringCircleRadius = planeHeight * 1.45;
  const ring = new THREE.RingGeometry(
    ringCircleRadius - ringWidth,
    ringCircleRadius,
    360,
    360
  );
  var ringMesh = new THREE.Mesh(ring, mat2);
  container.add(ringMesh);
  // LEFT GOAL SEMI CIRCLE
  const leftCircleRadius = planeHeight * 1.25;
  const leftCircleWidth = ringWidthBase;
  const ring2 = new THREE.RingGeometry(
    leftCircleRadius - leftCircleWidth,
    leftCircleRadius,
    360,
    360,
    -Math.PI / 2.945,
    Math.PI / 1.485
  );
  var ringMesh2 = new THREE.Mesh(ring2, mat2);
  container.add(ringMesh2);
  ringMesh2.position.x = -width / 2 + planeWidth * 2.5 + 0.005;
  // RIGH GOAL SEMI CIRCLE
  const ring3 = new THREE.RingGeometry(
    leftCircleRadius - leftCircleWidth,
    leftCircleRadius,
    360,
    360,
    Math.PI / 1.515,
    Math.PI / 1.475
  );
  var ringMesh3 = new THREE.Mesh(ring3, mat2);
  container.add(ringMesh3);
  ringMesh3.position.x = width / 2 - planeWidth * 2.5 - 0.005;

  let dotSize = 0.012;

  const dot = new THREE.RingGeometry(0, dotSize, 132, 12);
  var dotMesh = new THREE.Mesh(dot, mat2);
  container.add(dotMesh);
  // dotMesh.position.x=width/2 - planeWidth*2 - 0.005;

  const dot2 = new THREE.RingGeometry(0, dotSize, 132, 12);
  var dotMesh2 = new THREE.Mesh(dot2, mat2);
  container.add(dotMesh2);
  dotMesh2.position.x = width / 2 - planeWidth * 2;

  const dot3 = new THREE.RingGeometry(0, dotSize, 132, 12);
  var dotMesh3 = new THREE.Mesh(dot3, mat2);
  container.add(dotMesh3);
  dotMesh3.position.x = -width / 2 + planeWidth * 2;

  var goalLine = [];
  goalLine.push([0, -planeHeight], [0, planeHeight]);
  var goalLineGeo = new LineMesh(goalLine);
  var goalLineMesh = new THREE.Mesh(goalLineGeo, goaleLineMaterial);
  // container.add(goalLineMesh);
  goalLineMesh.position.x = -width / 2 + planeWidth * 0.2 - 0.005;

  var goalLine2 = [];
  goalLine2.push([0, -planeHeight], [0, planeHeight]);
  var goalLineGeo2 = new LineMesh(goalLine2);
  var goalLineMesh2 = new THREE.Mesh(goalLineGeo2, goaleLineMaterial);
  // container.add(goalLineMesh2);
  goalLineMesh2.position.x = width / 2 - planeWidth * 0.2 + 0.005;

  const geometry = new THREE.BoxGeometry(2.1, 1.4, 0.2, 10, 10, 10);
  const material = new THREE.MeshBasicMaterial({
    color: 0xff,
    side: THREE.FrontSide,
  });
  const plane = new THREE.Mesh(geometry, matss);

  //plane.position.z = -0.105;

  //container.add(plane);

  container.renderOrder = 10;

  // Plus sign geometry
  const plusLineMaterial = new THREE.MeshBasicMaterial({
    color: colorHero,
    side: THREE.DoubleSide,
  });
  plusLineMaterial.transparent = true;
  plusLineMaterial.opacity = 0.3;


  const plusLength = 0.005;
  const plusWidth = 0.005; // Example width of the plus sign arms

  const plusGeometry = new THREE.BufferGeometry();
  const halfLength = plusLength / 2;
  const halfWidth = plusWidth / 2;

  const plusVertices = new Float32Array([
    // Horizontal line
    -halfLength,
    -halfWidth,
    0,
    halfLength,
    -halfWidth,
    0,
    halfLength,
    halfWidth,
    0,

    -halfLength,
    -halfWidth,
    0,
    halfLength,
    halfWidth,
    0,
    -halfLength,
    halfWidth,
    0,

    // Vertical line
    -halfWidth,
    -halfLength,
    0,
    halfWidth,
    -halfLength,
    0,
    halfWidth,
    halfLength,
    0,

    -halfWidth,
    -halfLength,
    0,
    halfWidth,
    halfLength,
    0,
    -halfWidth,
    halfLength,
    0,
  ]);
  plusGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(plusVertices, 3)
  );

  const plusInstanceCount = rows * cols;
  const plusInstancedMesh = new THREE.InstancedMesh(
    plusGeometry,
    plusLineMaterial,
    plusInstanceCount
  );

  let index = 0;
  for (let i = 0; i < cols; i++) {
    for (let j = 0; j < rows; j++) {
      if (i > 0 && i < cols - 1 && j > 0 && j < rows - 1) {
        const plusMatrix = new THREE.Matrix4();
        const xPos = i * planeWidth - domainWidth / 2 + planeWidth / 2;
        const yPos = j * planeHeight - domainHeight / 2 + planeHeight / 2;
        plusMatrix.setPosition(xPos, yPos, 0);
        plusInstancedMesh.setMatrixAt(index, plusMatrix);
        index++;
      }
    }
  }

  // container.add(plusInstancedMesh);


  let fieldOutlineWidth = 0.004;
  let fieldOutlineWidthMax = 0.001;

  const updateField = (camera) => {

/*
    pitchOutlineMaterial.uniforms.thickness.value = Math.max(
      fieldOutlineWidth,
      (fieldOutlineWidthMax * Math.abs(camera.position.z)) / 10
    );

    middleLineMaterial.uniforms.thickness.value = Math.max(
      fieldOutlineWidth,
      (fieldOutlineWidthMax * Math.abs(camera.position.z)) / 10
    );

    goaleLineMaterial.uniforms.thickness.value = Math.max(
      fieldOutlineWidth * 4,
      (fieldOutlineWidthMax * 2 * Math.abs(camera.position.z)) / 10
    );

    mat4.uniforms.thickness.value = Math.max(
      fieldOutlineWidth,
      (fieldOutlineWidthMax * Math.abs(camera.position.z)) / 10
    );
*/


    //matss.uniforms.diffuse.value = new Color(0x666666);
  };

  const updateFieldColors = (color) => {
    //matss.uniforms.diffuse.value = new Color(0x666666);

    pitchOutlineMaterial.uniforms.diffuse.value = new Color(color);
    mat2.uniforms.diffuse.value = new Color(color);
    middleLineMaterial.uniforms.diffuse.value = new Color(color);
    mat4.uniforms.diffuse.value = new Color(color);
    goaleLineMaterial.uniforms.diffuse.value = new Color(color);
    plusLineMaterial.color = new Color(color);
  };


  return { container, updateField, updateFieldColors };
};

export { buildField };
